
import React from 'react';
import '../../resources/css/notice-page.css';
import i18n from '../../i18n';
import { DefaultRequest } from '../../requests/default.request';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import _ from 'lodash';

/**
 * 就餐指南
 */
class DiningGuide extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    constructor(props: Props) {
        super(props);
        this.state = {
            content: '',
            stringNode: []
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************
    public UNSAFE_componentWillMount() {
        this.getData()
    }
    public componentDidMount() { }

    // *********************
    // 方法区
    // *********************
    /**
     * 获取文本公告数据
     */
    getData = async () => {
        try {
            const result = await DefaultRequest.get_bulletin();
            const contentText = _.get(result, 'data[0].value', '')
            this.setState({
                content: contentText
            }, () => {
                const getString = this.typeReset();
                this.setState({
                    stringNode: getString
                })
            })
        }
        catch (error) {
            console.log("error", error)
        }
    }

    /**
     * 文字字段重构处理
     */
    public typeReset() {
        let basicNodeArr: Array<any> = [];
        const { content } = this.state;
        let contenSplit = content.split('\n')
        contenSplit.forEach((item: string, index: number) => {
            if (item) {
                basicNodeArr.push(<div key={index} style={{ textAlign: 'left', overflow: 'scroll' }}>{item}</div>)
            }
        });
        return basicNodeArr;
    }
    // *********************
    // 视图区
    // *********************

    render() {
        const { content } = this.state;
        return (

            <React.Fragment>
                <div className={'homeTitle'}>{i18n.t('home_page_text_announcement')}</div>
                {
                    !!content &&
                    <div className='guide-box'>
                        <div className='guide-content'>
                            {this.state.stringNode}
                        </div>
                    </div>
                }

            </React.Fragment>
        )
    }

}
export default withSnackbar(DiningGuide);

// **********
// TYPE
// **********

type Props = {

} & WithSnackbarProps

type State = {
    // 公告内容
    content: string;
    // 存储的字符节点
    stringNode: Array<any>;

}